import { render } from "./PesquisadorModal.vue?vue&type=template&id=77f6ff25&scoped=true"
import script from "./PesquisadorModal.vue?vue&type=script&lang=js"
export * from "./PesquisadorModal.vue?vue&type=script&lang=js"

import "./PesquisadorModal.vue?vue&type=style&index=0&id=77f6ff25&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-77f6ff25"

export default script